<template>
    <li class="nav-overlay__submenu-item">
        <a class="nav-overlay__submenu-link" :href="item.url">
            <span class="nav-overlay__submenu-link-text">
                {{ item.title }}
            </span>
            <span class="nav-overlay__submenu-icon">
                <Icon name="arrow" />
            </span>
        </a>
    </li>
</template>

<script>
import Icon from './Icon.vue';

export default {
    name: 'NavOverlayItemChild',
    data() {
        return {
            item: [],
        };
    },
    components: {
        Icon
    },
    props: ['child'],
    mounted: function() {
        this.item = this.child;
    },
};
</script>